import React, { Fragment } from "react";
import Dropdown from "./Dropdown";
import { iconDeleteDropdown, iconEdit, iconFileDropdown, iconDownload } from "./icons";

const CardItem = ({ data, id, deleteAction, DownloadACtion }) => {
  let filename = data && data.url ? data.url.split('/') : ""
  return (
    <Fragment key={id}>
      <div
        className={`rd--file-card ${
          data.hasError ? "rd--file-card--error " : ""
        }`}
      >
        <div className="rd--file-card__content">
          <div className="rd--file-card__toogle">
            <Dropdown>
              <Dropdown.Item
                onClick={() => deleteAction(id)}
                icon={iconDeleteDropdown}>
                Eliminar
              </Dropdown.Item>
              {
                !(data.isNew) && !!DownloadACtion &&
                  <Dropdown.Item onClick={() => DownloadACtion()} icon={iconDownload}>
                    Descargar
                  </Dropdown.Item>
              }
            </Dropdown>
          </div>

          <div className="rd--file-card__info">
            <div className="rd--file-card__info-type">Archivo: </div>
            <div className="rd--file-card__info-name file">
              {iconFileDropdown}
              <span>{data && data.url ? filename[filename.length - 1] : data.file.name}</span>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default CardItem;
